module.exports = __webpack_public_path__ + "img/OANDA_Onboarding_HeaderAnim_IT.33a37b12.png";